export class CurrentUserModel {
    id: any
    role: any
    role_no: any
    email: any
    employee_name: any
    employee_no: any
    clinic_no: any
    tenant_no: any

    constructor(
        id: any,
        role: any,
        role_no: any,
        email: any,
        employee_name: any,
        employee_no: any,
        clinic_no: any,
        tenant_no: any
    ) {
        this.id = id
        this.role = role
        this.role_no = role_no
        this.email = email
        this.employee_name = employee_name
        this.employee_no = employee_no
        this.clinic_no = clinic_no
        this.tenant_no = tenant_no
    }
}